import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'NutrifyMe by Dietitian Prachi';
const DEFAULT_IMAGE = 'https://images.pexels.com/photos/15319037/pexels-photo-15319037.jpeg?auto=compress&w=1200';

const Seo = ({
  title,
  description,
  keywords = [],
  image = DEFAULT_IMAGE,
  path = '/',
  type = 'website',
  jsonLd = null,
  publishedDate,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Personalised Nutrition That Works`;
  const canonical = typeof window !== 'undefined' ? `${window.location.origin}${path}` : path;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(', ')} />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      {publishedDate && <meta property="article:published_time" content={publishedDate} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Robots */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
